
import Vue from 'vue'

import RegisterSuccess from './RegisterSuccess.vue'

const Instance = Vue.extend(RegisterSuccess);
const element = new Instance().$mount();

const promp = {
    open({ token, name, userId }) {
        document.body.appendChild(element.$el);
        element.setToken({ token, name, userId });
    },
    close() {
        document.body.removeChild(element.$el);
    }
}

export default promp;